// src/components/PodcastSection.jsx
import { useState } from "react";
import { Youtube, Play, Mic } from "lucide-react";

const YT_RED = "#ff3333";

export default function PodcastSection() {
  const [imgOk, setImgOk] = useState(true);

  return (
    <div className="toa-dis" id="podcast">
      <div className="toa-dis-in">
        {/* ── Preview (video mock) — shown first on this section for rhythm ── */}
        <div className="toa-dis-prev">
          <a
            href="https://youtube.com/@TheOnesAboveMedia"
            target="_blank"
            rel="noreferrer"
            style={{
              position: "relative",
              display: "block",
              width: "100%",
              aspectRatio: "16 / 9",
              borderRadius: 8,
              overflow: "hidden",
              background: "linear-gradient(145deg,#1a1a2e,#0c0c16)",
              border: "1px solid rgba(255,51,51,.18)",
              textDecoration: "none",
            }}
          >
            {/* Thumbnail image — drop a file at public/podcast-thumbnail.jpg to show it here */}
            {imgOk && (
              <img
                src={`${process.env.PUBLIC_URL}/podcast-thumbnail.png`}
                alt="The Ones Above — latest episode"
                onError={() => setImgOk(false)}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            )}

            <div
              style={{
                position: "absolute",
                inset: 0,
                background: imgOk
                  ? "linear-gradient(180deg, rgba(10,10,20,.15) 0%, rgba(10,10,20,.55) 100%), radial-gradient(ellipse at 50% 40%, rgba(255,51,51,.12), transparent 70%)"
                  : "radial-gradient(ellipse at 50% 40%, rgba(255,51,51,.14), transparent 70%)",
              }}
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: 62,
                  height: 62,
                  borderRadius: "50%",
                  background: "rgba(255,51,51,.92)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0 30px rgba(255,51,51,.45)",
                }}
              >
                <Play
                  style={{
                    width: 24,
                    height: 24,
                    color: "#fff",
                    marginLeft: 3,
                  }}
                  fill="#fff"
                />
              </div>
            </div>
          </a>

          <div
            className="toa-dhdr"
            style={{ marginTop: 14, marginBottom: 0 }}
          >
            <div
              className="toa-dpfp"
              style={{
                background: "rgba(255,51,51,.12)",
                border: "1px solid rgba(255,51,51,.25)",
              }}
            >
              <Mic style={{ width: 18, height: 18, color: YT_RED }} />
            </div>
            <div>
              <div className="toa-dname">The Ones Above</div>
              <div className="toa-dtime">@TheOnesAboveMedia · YouTube</div>
            </div>
          </div>
        </div>

        {/* ── Copy ── */}
        <div>
          <div className="toa-slbl">Now Streaming</div>
          <div className="toa-stit">The TOA Podcast</div>
          <div className="toa-sdiv" />
          <p className="toa-ssub" style={{ marginBottom: 26 }}>
            Our community channel - built mainly around the podcast, but also home to
            charity streams, events, giveaways, and everything else happening across the
            brotherhood. New uploads regularly on YouTube.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <a
              href="https://youtube.com/@TheOnesAboveMedia"
              target="_blank"
              rel="noreferrer"
              className="toa-btn toa-btn-p"
              style={{
                fontSize: 14,
                padding: "13px 28px",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: YT_RED,
                borderColor: YT_RED,
              }}
            >
              <Youtube style={{ width: 18, height: 18 }} />
              Watch on YouTube
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}